import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'IssueFormCompaniesController',
            IssueFormCompaniesController
        );

    function IssueFormCompaniesController(
        BusinessRelationshipsFactory,
    ) {
        var vm = this;

        BusinessRelationshipsFactory.fetchServiceProviders({
            page_size: 1000
        }).then(function (response) {
            vm.dataFromBackend = response.data.results;
        })
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/companies/issue_form_companies.controller.ts